import { render, staticRenderFns } from "./EditInstructionsModal.vue?vue&type=template&id=6da04dd9&scoped=true&"
import script from "./EditInstructionsModal.vue?vue&type=script&lang=js&"
export * from "./EditInstructionsModal.vue?vue&type=script&lang=js&"
import style0 from "./EditInstructionsModal.vue?vue&type=style&index=0&id=6da04dd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da04dd9",
  null
  
)

export default component.exports